module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New driver","name":"Name","phone":"Phone","email":"Mail","save":"Save","cancel":"Cancel"},"no":{"title":"Ny sjåfør","name":"Navn","phone":"Telefon","email":"E-post","save":"Lagre","cancel":"Avbryt"}}')
  delete Component.options._Ctor
}
